/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type QuoteWizard_ApplyQuoteItemActionsMutationVariables = Types.Exact<{
  input: Types.ApplyQuoteItemActionsInput;
}>;


export type QuoteWizard_ApplyQuoteItemActionsMutation = { applyQuoteItemActions: { __typename: 'ApplyQuoteItemActionsResult', quote: { __typename: 'Quote', id: string } } };


export const QuoteWizard_ApplyQuoteItemActionsDocument = gql`
    mutation QuoteWizard_applyQuoteItemActions($input: ApplyQuoteItemActionsInput!) {
  applyQuoteItemActions(input: $input) {
    quote {
      id
    }
  }
}
    `;
export type QuoteWizard_ApplyQuoteItemActionsMutationFn = Apollo.MutationFunction<QuoteWizard_ApplyQuoteItemActionsMutation, QuoteWizard_ApplyQuoteItemActionsMutationVariables>;

/**
 * __useQuoteWizard_ApplyQuoteItemActionsMutation__
 *
 * To run a mutation, you first call `useQuoteWizard_ApplyQuoteItemActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuoteWizard_ApplyQuoteItemActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quoteWizardApplyQuoteItemActionsMutation, { data, loading, error }] = useQuoteWizard_ApplyQuoteItemActionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuoteWizard_ApplyQuoteItemActionsMutation(baseOptions?: Apollo.MutationHookOptions<QuoteWizard_ApplyQuoteItemActionsMutation, QuoteWizard_ApplyQuoteItemActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuoteWizard_ApplyQuoteItemActionsMutation, QuoteWizard_ApplyQuoteItemActionsMutationVariables>(QuoteWizard_ApplyQuoteItemActionsDocument, options);
      }
export type QuoteWizard_ApplyQuoteItemActionsMutationHookResult = ReturnType<typeof useQuoteWizard_ApplyQuoteItemActionsMutation>;
export type QuoteWizard_ApplyQuoteItemActionsMutationResult = Apollo.MutationResult<QuoteWizard_ApplyQuoteItemActionsMutation>;
export type QuoteWizard_ApplyQuoteItemActionsMutationOptions = Apollo.BaseMutationOptions<QuoteWizard_ApplyQuoteItemActionsMutation, QuoteWizard_ApplyQuoteItemActionsMutationVariables>;